<template>
<div v-if="dataLoaded">
    <table-page
        :client="client"
        @updated="getData"
        :warnings="warnings"
        :changelogs="changelogs"
        :hideTabs="true"
    >
        <fast-table
            :recordLabel="recordLabel"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentRowId"
            @click="currentRowId = $event.id"
        >
            <template v-slot:table-actions>
                <button class="btn btn-primary btn-collapse" id="addButton" @click="openAddModal">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Insurance Plan</span>
                </button>
            </template>
        </fast-table>

        <add-form-modal
            v-if="addModalOpen"
            :client="client"
            @updated="getData"
            @close="addModalOpen = false"
        />
    </table-page>

    <sidebar
        v-if="currentRowId"
        :client="client"
        :insurance-plan-id="currentRowId"
        @updated="getData"
        @close="currentRowId = null"
    >
    </sidebar>
</div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import Sidebar from './components/InsurancePlans/Sidebar'
import AddFormModal from './components/InsurancePlans/AddFormModal'

export default {
    components: {FastTable, Sidebar, AddFormModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentRow() {
            return this.insurancePlans.find(x => (x.id == this.currentRowId))
        },
        sections() {
            return [
                {title: 'Current', defaultIsClosed: false, id: 'current', hasDateFilter: false},
                {title: 'Future', defaultIsClosed: false, id: 'future', hasDateFilter: false},
                {title: 'Past', defaultIsClosed: true, id: 'past', hasDateFilter: false},
            ]
        },
        tableData() {
            const tableData = []

            const sections = [
                this.insurancePlans.filter(obj => obj.is_future),
                this.insurancePlans.filter(obj => obj.is_active),
                this.insurancePlans.filter(obj => obj.is_past),
            ]

            sections.forEach((section, idx) => {
                const sectionData = []

                section.forEach(obj => {
                    const company = this.client.companies.find(c => c.id == obj.company_id)
                    sectionData.push({
                        id: obj.id,
                        object: obj,
                        cells: [
                            obj.plan_name,
                            company.name,
                            obj.plan_type_pretty,
                            obj.has_hsa ? 'Yes' : 'No',
                            obj.ends_on,
                        ],
                    })
                })

                tableData.push(sectionData)
            })

            return tableData
        },
    },
    data() {
        return {
            insurancePlans: [],
            dataLoaded: false,
            currentRowId: null,
            recordLabel: "Insurance Plans",
            headers: [
                {label: 'Plan Name', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Company', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Type', classes: '', isSearchable: false, isFilterable: true},
                {label: 'HSA?', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Renewal Date', classes: '', isSearchable: false, isFilterable: false, type: 'date'},
            ],
            addModalOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Insurance Plans')
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/insurance-plans`).then(resp => {
                this.dataLoaded = true
                this.insurancePlans = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
        openAddModal() {
            this.addModalOpen = true
        },
    },
}
</script>
